
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m256 8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-160c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-160c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"}})])
          )
        }
      }
    